import React from 'react';
import Box from '@mui/material/Box';
import { translations } from 'src/constants/translations';
import { Loader } from 'src/components/Loader';
import { useUsersManage } from 'src/components/profileComponents/Users/hooks/useUsersManage';
import { ICrumbs } from 'src/components/profileComponents/Breadcrumbs';
import { usersPageAction } from 'src/components/profileComponents/Users/types';
import { UserAction } from 'src/components/profileComponents/Users/components/UserAction';
import { appIcon } from 'src/assets';
import { TypeOfRole } from 'src/typings/user';
import { useUser } from 'src/hooks/user';
import { UsersPageWrapper } from 'src/components/profileComponents/Users/components/UsersPageWrapper';
import { useStyles } from './styles';

export const Users = () => {
  const { initialUsersDataIsLoading } = useUsersManage();
  const styles = useStyles();
  const { currentUserRole } = useUser();

  const actionsList: usersPageAction[] = [{
    id: 1,
    name: 'Manage users',
    description: 'Browse, search and edit existing users',
    icon: appIcon.iconUsers.default,
    btn: appIcon.iconChevronRight.default,
    link: '/profile/users/manage',
    rolesAccess: [TypeOfRole.rootadmin, TypeOfRole.superadmin, TypeOfRole.admin, TypeOfRole.supervisor, TypeOfRole.partner],
  }, {
    id: 2,
    name: 'Create user',
    description: 'Add single user or multiple users',
    icon: appIcon.iconAddUser.default,
    btn: appIcon.iconChevronRight.default,
    link: '/profile/users/create',
    rolesAccess: [TypeOfRole.rootadmin, TypeOfRole.superadmin, TypeOfRole.admin, TypeOfRole.supervisor, TypeOfRole.partner],
  }];

  if (initialUsersDataIsLoading) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Loader />
      </Box>
    );
  }

  const crumbs: ICrumbs[] = [
    {
      name: translations.usersLink.toUpperCase(),
    },
  ];

  return (
    <UsersPageWrapper
      crumbs={crumbs}
      title={translations.usersLink}
    >
      <>
        <div className={styles.chooseAnAction}>
          {translations.chooseAnAction}
        </div>
        <Box className={styles.actionsList}>
          { (actionsList.map((action) => {
            if ((currentUserRole && !action.rolesAccess.includes(currentUserRole))) return null;
            return (
              <React.Fragment key={action.id}>
                <UserAction action={action} />
              </React.Fragment>
            );
          })) }
        </Box>
      </>
    </UsersPageWrapper>
  );
};
